const UNITS = ["year", "month", "day", "hour", "minute", "second"];
export default function createNumberFormatter(locale, options = {}) {
  return (values) => UNITS.map((unit) => {
    const value = values[unit];
    if (value) {
      const formatter = new Intl.RelativeTimeFormat(locale, options);
      const parts = formatter.formatToParts(value, unit);
      return `${parts[1]?.value ?? ""}${parts[2]?.value ?? ""}`;
    }
    return "";
  }).join(" ");
}
